const ImageEndpoint = {
  CHECK: '/default/image/check',
};

export default ImageEndpoint;
